import React from 'react'
import styles from './ConsumablesOptionRenderer.module.scss'
import { ConsumablesOptionRendererProps } from './ConsumablesOptionRenderer.types'

const ConsumablesOptionRenderer: React.FC<ConsumablesOptionRendererProps> = ({
  props,
  option,
}) => {
  return (
    <div className={styles.consumablesOptionRenderer}>
      <li {...props}>
        <div className={styles.container}>
          <div className={styles.title}>
            {option?.originalDescription || option?.name}
          </div>
          <div className={styles.metaContainer}>
            {option?.catalogNumber && (
              <span className={`${styles.badge} ${styles.title}`}>
                <strong className={styles.label}>CN:</strong>{' '}
                {option.catalogNumber}
              </span>
            )}
            {option?.manufacturer && (
              <span className={`${styles.badge} ${styles.title}`}>
                <strong className={styles.label}>MFC:</strong>{' '}
                {option.manufacturer}
              </span>
            )}
            {option?.isMultipack && (
              <span className={`${styles.badge} ${styles.title}`}>
                <strong className={styles.label}>MULTIPACK</strong>
              </span>
            )}
            {option?.isInCatalog && (
              <span
                className={`${styles.badge} ${styles.title} ${styles.inCatalog}`}
              >
                <strong className={styles.label}>IN CATALOG</strong>
              </span>
            )}
          </div>
        </div>
      </li>
    </div>
  )
}

export default ConsumablesOptionRenderer
